import { Box, useToken } from "@chakra-ui/react";
import { animate } from "framer-motion";
import React, { useEffect, useState } from "react";
import { SkeletonContext } from "./skeleton-context";
const chakraComponentSelectors = [
    "chakra-avatar",
    "chakra-button",
    "chakra-badge",
    "chakra-status-indicator-light",
    "chakra-code",
    "chakra-input__group",
    "hightouch-ui-skeleton-box",
]
    .map((className) => `[class*="${className}"]`)
    .join(", ");
export function Skeleton({ isLoading, ...props }) {
    const [gray100, gray300] = useToken("colors", ["gray.200", "gray.300"]);
    const [color, setColor] = useState(gray100);
    useEffect(() => {
        if (!isLoading) {
            return;
        }
        const controls = animate(gray100, gray300, {
            type: "tween",
            duration: 0.8,
            repeat: Number.POSITIVE_INFINITY,
            repeatType: "mirror",
            onUpdate(latest) {
                setColor(latest);
            },
        });
        return () => {
            controls.stop();
        };
    }, [isLoading]);
    return (React.createElement(SkeletonContext.Provider, { value: isLoading },
        React.createElement(Box, { style: {
                // @ts-expect-error types for `style` prop don't accept CSS variables
                "--skeleton-color": color,
            }, css: {
                ...(isLoading
                    ? {
                        [chakraComponentSelectors]: {
                            position: "relative",
                            borderColor: "transparent",
                            pointerEvents: "none",
                            userSelect: "none",
                            // eslint-disable-next-line @typescript-eslint/naming-convention
                            "&::after": {
                                content: '""',
                                position: "absolute",
                                inset: 0,
                                borderRadius: "inherit",
                                background: "var(--skeleton-color)",
                            },
                        },
                        ".chakra-input__left-element": {
                            opacity: 0,
                        },
                    }
                    : {}),
            }, ...props })));
}
